
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DialogCardTitle from "@/components/ui/DialogCardTitle.vue";
import { getModule } from "vuex-module-decorators";
import { Auth, Storage } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import VpDialog from "@/components/ui/VpDialog.vue";

import FlashNotifications from "@/store/modules/FlashNotifications";

const flashNotificationsModule = getModule(FlashNotifications);
@Component({
    name: "FactorDocumentsUploader",
    components: {
        DialogCardTitle,
        VpDialog,
    },
})
export default class FactorPdfUploader extends Vue {
    @Prop({ default: false, type: Boolean })
    clearForm!: boolean;

    private file: Array<File> | null = null;
    private userName = "";
    private fileUploaded = false;
    private isLoading = false;

    async mounted(): Promise<void> {
        let authUser = await Auth.currentAuthenticatedUser();
        this.userName = authUser.username;
    }

    get uploadedPdf(): File | string {
        return this.file && this.file.length > 0
            ? URL.createObjectURL(this.file[0])
            : "";
    }

    private renderFile(e: any): void {
        this.fileUploaded = false;
        if (e.length > 0 && this.file) {
            const reader = new FileReader();
            let pageNumber = 1;
            reader.readAsBinaryString(this.file[0]);
            reader.onload = (e: any) => {
                // pageNumber = e.target.result.match(
                //     /\/Type[\s]*\/Page[^s]/g
                // ).length;
                // this.$emit("loaded", pageNumber);
            };
        } else {
            this.$emit("loaded", 1);
        }
    }

    private async uploadMediaFile(): Promise<void> {
        this.isLoading = true;

        if (!this.file || this.file.length === 0) {
            this.isLoading = false;
            return;
        }

        const uploadedFileNames: string[] = [];

        const uploadPromises = this.file.map((file) => {
            const fileName = uuidv4();
            const fileExtension = file.name.split(".").pop();
            const key = `${this.userName}/${fileName}.${fileExtension}`;

            return new Promise<void>((resolve, reject) => {
                Storage.put(key, file, {
                    resumable: true,
                    contentType: file.type,
                    completeCallback: () => {
                        uploadedFileNames.push(`${fileName}.${fileExtension}`);
                        flashNotificationsModule.success({
                            message: `Successfully uploaded ${file.name}`,
                            duration: 5000,
                        });
                        resolve();
                    },
                    errorCallback: (err) => {
                        flashNotificationsModule.error({
                            message: `Unexpected error while uploading ${file.name}: ${err}`,
                            duration: 10000,
                        });
                        reject(err);
                    },
                });
            });
        });

        try {
            await Promise.all(uploadPromises);
            this.fileUploaded = true;
            this.isLoading = false;

            const emitData =
                uploadedFileNames.length === 1
                    ? uploadedFileNames[0]
                    : uploadedFileNames;
            console.log(emitData);
            this.$emit("uploaded", emitData);
        } catch (error) {
            console.error(error);
            this.fileUploaded = false;
            this.isLoading = false;
        }

        // this.isLoading = true;
        // let file = this.file ? this.file : null;

        // if (!file) return;

        // console.log(this.file)

        // try {
        //     const fileName = uuidv4();
        //     const fileExtension = file[0].name.split(".").pop();
        //     const key = `${this.userName}/${fileName}.${fileExtension}`;
        //     await Storage.put(key, file[0], {
        //         resumable: true,
        //         contentType: file[0].type,
        //         completeCallback: () => {
        //             flashNotificationsModule.success({
        //                 message: `Successfully uploaded`,
        //                 duration: 5000,
        //             });
        //             this.fileUploaded = true;
        //             this.isLoading = false;
        //             this.$emit("uploaded", `${fileName}.${fileExtension}`);
        //         },
        //         errorCallback: (err) => {
        //             this.fileUploaded = false;
        //             this.isLoading = false;
        //             flashNotificationsModule.error({
        //                 message: `Unexpected error while uploading ${err}`,
        //                 duration: 10000,
        //             });
        //         },
        //     });
        // } catch (error) {
        //     console.log(error);
        //     this.isLoading = false;
        //     flashNotificationsModule.error({
        //         message: `Unexpected error while uploading ${error}`,
        //         duration: 10000,
        //     });
        // }
    }

    @Watch("clearForm")
    private onFactorsCreated() {
        this.file = null;
    }
}
